import { GalleryConfig } from 'rangeConfig/@types';

const paxDefaultGallery = [
  { id: 'SPR-39499319' },
  { id: 'SPR-09482240' },
  { id: 'SPR-19478025' },
  { id: 'SPR-99221371' },
  { id: 'SPR-09433221' },
  { id: 'SPR-49420293' },
  { id: 'SPR-49478241' },
  { id: 'SPR-79431577' },
  { id: 'SPR-39218512' },
  { id: 'SPR-59478250' },
  { id: 'SPR-29478181' },
  { id: 'SPR-89502654' },
  { id: 'SPR-89502649' },
  { id: 'SPR-19502327' },
  { id: 'SPR-99503139' },
  { id: 'SPR-69502891' },
  { id: 'SPR-79502715' },
  { id: 'SPR-79503135' },
  { id: 'SPR-79502334' },
  { id: 'SPR-29502548' },
  { id: 'SPR-79502800' },
  { id: 'SPR-79568546' },
  { id: 'SPR-79559165' },
  { id: 'SPR-39560967' },
  { id: 'SPR-39562768' },
  { id: 'SPR-29562603' },
  { id: 'SPR-99562609' }
];

// This gallery is used for the Japanese and South Korean market with 201 cm high frames only
const paxGallery201 = [
  { id: 'SPR-09478083' },
  { id: 'SPR-79384260' },
  { id: 'SPR-99221371' },
  { id: 'SPR-49433224' },
  { id: 'SPR-89420291' },
  { id: 'SPR-99478234' },
  { id: 'SPR-39478010' },
  { id: 'SPR-09482240' },
  { id: 'SPR-99478253' },
  { id: 'SPR-29478181' }
];

const paxGalleryConfig: GalleryConfig = {
  default: [{ sprs: paxDefaultGallery }],
  KR: [{ sprs: paxGallery201 }],
  JP: [{ sprs: paxGallery201 }],
  CL: [{ sprs: paxGallery201 }]
};

export default paxGalleryConfig;
